import { useDispatch, useSelector } from 'react-redux';
import { getCurrentTemplateTransaction, getLogRedirectionData } from '../../../store/global/selectors';
import {getTransactionState} from '../../../store/global/selectors';
import "./style.css"

import Datflow from '../../molecules/bluePrintComponents/DataFlow/index'
import TemplateTransaction from '../../molecules/bluePrintComponents/DataFlow/TemplateTransaction';
import { useEffect, useState } from 'react';
import DiagramCanvas from '../../molecules/bluePrintComponents/DataFlow/DiagramCanvas';
import { DiagramHOC } from '../../molecules/bluePrintComponents/DataFlow/DiagramHOC';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';
import { invokeGetService } from '../../../store/global/actions';
import CompactAlert from '../../molecules/logs/LogRedirectionAlert';
import { Box } from '@material-ui/core';

export default function Transaction() {
    const params = useParams();
    let transactionId = params.transaction;

    const dispatch = useDispatch();
    const history = useHistory();

    const [slug, blueprintID] = window.location.href?.split('/').slice(4);

    
    const [loading, setLoading] = useState(true);
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [allClusterlets, setAllClusterlets] = useState([]);
    const [allEvents, setAllEvents] = useState([]);
    const [allTransactions, setAllTransactions] = useState([]);
    const [allConnections, setAllConnections] = useState([]);
    const [messages, setMessages] = useState([]) 
    const [utilityFunctions, setUtilityFunctions] = useState([]);
    const logRedirectionData = useSelector(getLogRedirectionData);

    // const [key] = useState(Math.random(1, 99999));
    // const templateTransaction = useSelector(getCurrentTemplateTransaction);
    // const transactionState = useSelector(getTransactionState);
    // let {drawEvent,drawNestedTransaction} = transactionState

    // const WrappedDiagramCanvas = DiagramHOC(DiagramCanvas);
    function buildMessageStructure({ transaction, allTransactions, allEvents, allMessages, allFields }) {
        // Helper: find event by ID
        function getEventById(eventId) {
          return allEvents.find(ev => ev._id === eventId);
        }
      
        // Helper: find message by ID
        function getMessageById(messageId) {
          return allMessages.find(msg => msg._id === messageId);
        }
      
        // Build field tree recursively
        function buildFieldTree(messageId) {
          // top-level fields = fields whose parent.id === messageId
          const topFields = allFields.filter(field =>
            field.parent && field.parent.some(p => p.id === messageId && p.type === "message")
          );
      
          function buildChildren(fieldId) {
            const children = allFields.filter(f =>
              f.parent && f.parent.some(p => p.id === fieldId && p.type === "field")
            );
      
            return children.map(child => ({
              fieldId: child._id,
              fieldName: child.name,
              attributes: child.attributes,
              type: child.type,
              children: buildChildren(child._id)
            }));
          }
      
          return topFields.map(f => ({
            fieldId: f._id,
            fieldName: f.name,
            attributes: f.attributes,
            type: f.type,
            children: buildChildren(f._id)
          }));
        }
      
        // Build messages from transaction events
        const messages = (transaction.events || []).map(eventRef => {
          const ev = getEventById(eventRef.id);
          if (!ev) return null;
      
          const msg = getMessageById(ev.message);
          if (!msg) return null;
      
          return {
            eventId: ev._id,
            evenName: ev.name,
            messageId: msg._id,
            fieldName: msg.name,
            children: buildFieldTree(msg._id)
          };
        }).filter(Boolean);
      
        // Handle nested transactions (flatten results)
        const nested = (transaction.nestedTransactions || []).flatMap(nestedTx => {
          const txDetails = allTransactions.find(tx => tx._id === nestedTx.id);
          if (!txDetails) return [];
          return buildMessageStructure({ transaction: txDetails, allTransactions, allEvents, allMessages, allFields });
        });
      
        // Return only simplified format
        return [...messages, ...nested];
      }
      
      


    useEffect(() => {
        setLoading(true)
        
        dispatch( invokeGetService("getTransactionAssociates", [transactionId]) )
        .then(response => {
            if(response?.status){
                const data = response?.data
                console.log(data,'this is data')
                setSelectedTransaction(data?.transaction);
                setAllEvents(data?.allEvents);
                setAllClusterlets(data?.allClusterlets);
                setAllTransactions(data?.allTransaction);
                setAllConnections(data?.connections);
                setUtilityFunctions(data?.utilityFunctions);
                setLoading(false);
                const st_messages = buildMessageStructure({transaction: data?.transaction, allEvents: data?.allEvents, allTransactions: data?.allTransaction, allMessages: data?.messages, allFields: data?.allFields})
                setMessages(st_messages)
            }else if (response?.code === 255 && response.transactionNotFound) {
                history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
            } else {
                console.error("Failed to fetch transaction details");
            }
        }).catch(error => {
            console.error("Failed to fetch transaction details", error);
        })
    }, [transactionId])
    return (
        // <>
        //     <div className={drawNestedTransaction ? "custom-cursor" :""}  >
        //         {/* {templateTransaction == '' && <Datflow />} */}
        //         {templateTransaction === '' && <WrappedDiagramCanvas />}
        //         {/* {templateTransaction !== '' && <TemplateTransaction key={key} transaction={templateTransaction} />} */}
        //     </div>
        // </>
        // <WrappedDiagramCanvas />

        <>
            {
              (logRedirectionData?.parent === "transaction" && logRedirectionData.parentId === transactionId) && !logRedirectionData.entity ?
                <Box style={{position: 'fixed', width: 'calc(100% - 330px)', zIndex: 100, top: '75px', left: '245px'}}>
                  <CompactAlert severity={logRedirectionData?.level} >{logRedirectionData?.message}</CompactAlert>
                </Box>
              :
              null
            }
            {loading && <LoaderWithProgress isLoader={true} styleRoot={{ overflow: 'hidden', height: '100%' }} /> }
            {!loading && selectedTransaction !== null &&  
                <DiagramCanvas 
                    transactionId={transactionId} 
                    setLoading={setLoading}  
                    selectedTransaction={selectedTransaction} 
                    allConnections={allConnections} 
                    allEvents={allEvents} 
                    allClusterlets={allClusterlets} 
                    allTransactions={allTransactions}  
                    messages={messages}
                    utilityFunctions={utilityFunctions}
                /> 
            } 
        </>

    )
}